@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.row {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    padding: 30px 0;
    border-bottom: 1px solid var(--color-black);

    @include breakpoint.breakpoint(layout.$belowMedium) {
        padding: 30px;
    }
}

.pubDate {
    font-size: 2.25rem;
    line-height: 1.15;
    grid-column: span 2;
}

.title {
    grid-column: span 10;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: span 12;
    }

    h2 {
        font-size: 2.8125rem;
        line-height: 1;
    }

    a {
        color: var(--color-lobster);
        display: block;
        font-size: 1.125rem;
        margin-top: 0.25rem;
        text-transform: uppercase;
        text-decoration: none;
    }
}
